/** True if `value` is unchanged by URI encoding. */
export const isUriSafe = (value: string) => encodeURI(value) === value;

const URL_PATTERN =
  /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.)+[a-z]{2,}|(localhost)|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/;

/** True if `value` is a valid URL. */
export const isURL = (value: string) => URL_PATTERN.test(value);
